import { DataDefinition } from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";

export type CursorDataOptions = {
	id: string;
	query: DataDefinition;
	weeklyLimits: { exceedance: string | null; warning: string | null };
};

export const defaultCursorValueDataOptions = createPluginOptions()({
	data: [] as CursorDataOptions[],
});

export type CursorValueDataOptions = typeof defaultCursorValueDataOptions;
